import { render, staticRenderFns } from "./EmployeeProfileTabs.vue?vue&type=template&id=84f10fa8&scoped=true&"
import script from "./EmployeeProfileTabs.vue?vue&type=script&lang=js&"
export * from "./EmployeeProfileTabs.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeProfileTabs.vue?vue&type=style&index=0&id=84f10fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f10fa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCardText,VCol,VForm,VIcon,VSnackbar,VTab,VTabs})
